import React, { useEffect } from 'react';

import { saveQuiz } from '@redux/quiz/actions';
import { quizFormNextStep } from '@redux/quiz/actions';
import { useDispatch } from 'react-redux';


import { useForm, useFieldArray } from 'react-hook-form';
import Form from 'react-bootstrap/Form';
import Alert from 'react-bootstrap/Alert';

import Attendance from '@images/homepage/quiz/attendance.svg';
import Billing from '@images/homepage/quiz/billing.svg';
import Classroom from '@images/homepage/quiz/classroom.svg';
import Communication from '@images/homepage/quiz/comm.svg';
import Engage from '@images/homepage/quiz/engage.svg';
import Growth from '@images/homepage/quiz/growth.svg';
import Lesson from '@images/homepage/quiz/lesson.svg';
import Waitlist from '@images/homepage/quiz/waitlist.svg';

import Row from '@common/Row';

const options = [
  { 
    id: 'prodQuizGoals3Admin',
    key: 'Billing & payments',
    image: Billing,
    color: 'teal',
    value: 'core'
  },
  { 
    id: 'prodQuizGoals5Activities',
    key: 'Classroom materials',
    image: Classroom,
    color: 'yellow',
    value: 'curriculum'
  },
  { 
    id: 'prodQuizGoals7Attendance',
    key: 'Attendance tracking',
    image: Attendance,
    color:'green',
    value: 'core'
  },
  {
    id: 'prodQuizGoals2ParentComms',
    key: 'Family communication',
    image: Communication,
    color: 'red',
    value: 'core'
  },
  {
    id: 'prodQuizGoals4TeacherSkills',
    key: 'Educator growth',
    image: Growth,
    color: 'teal',
    value: 'academy'
  },
  {
    id: 'prodQuizGoals6LessonPlanning',
    key: 'Lesson planning',
    image: Lesson,
    color: 'yellow',
    value: 'digital curriculum'
  },
  {
    id: 'prodQuizGoals8Insights',
    key: 'Waitlist management',
    image: Waitlist,
    color:'green',
    value: 'core'
  },
  { 
    id: 'prodQuizGoals1TeacherEngagement',
    key: 'Educator engagement',
    image: Engage,
    color: 'red',
    value: 'core'
  }
];

const StepOne = ({ nextStep }) => {
  const { control, register, formState: { errors }, handleSubmit, watch } = useForm({
    defaultValues: {
      recommend: [{}]
    }
  });
  const { fields } = useFieldArray({
    control,
    name: 'recommend',
  });
  const dispatch = useDispatch();
  const onSubmit = (data) => {
    dispatch(saveQuiz(data));
    dispatch(quizFormNextStep());
    nextStep()
  };
  const onChange = (data) => {
    dispatch(saveQuiz(data));
  }
  useEffect(() => {
    const subscription = watch((value) => onChange(value));
    return () => subscription.unsubscribe();
  }, [watch]);
  return (
    <Form noValidate onSubmit={handleSubmit(onSubmit)}>
      <Row className='row-cols-2 row-cols-xl-3 gy-2 mb-3'>
        {options.map((item,index) => (
          <div key={index} className='d-flex demo-quiz-checkbox'>
            {fields.map((field) => (
              <Form.Check key={field.id} className='d-flex flex-fill p-0'>
                <Form.Check.Label className='d-flex flex-column flex-fill bg-white text-center border border-3 px-3 py-4 border-black rounded-3 position-relative' style={{cursor: 'pointer'}}>
                  <div className='d-flex justify-content-center'>
                    <img className={`rounded bg-${item.color}`} src={item.image} alt={item.key} style={{ aspectRatio: '1 / 1', padding: 10 }}/>
                  </div>
                  <Form.Check.Input type={'checkbox'} style={{position: 'absolute', left: 39, top: 5}} value={item.id} {...register(`recommend`, { validate: v => v.length > 0 && v[0].constructor !== Object })}/>
                  <p className='mt-2 mb-0 fs-16'>{item.key}</p>
                </Form.Check.Label>
              </Form.Check>
            ))}
          </div>
        ))}
        <div className='d-none d-xl-flex'>
          <button type='submit' className='btn btn-primary btn-lg w-100'>{'See how Lillio can help ➜'}</button>
        </div>
      </Row>
      {errors.recommend &&
        <Alert variant={'primary'}>
          {'At least one option is required'}
        </Alert>
      }
      <div className='d-flex d-xl-none'>
        <button type='submit' className='btn btn-primary btn-lg w-100'>{'See how Lillio can help ➜'}</button>
      </div>
    </Form>
  )
}

export default StepOne
